import { CRUD } from "@/shared/components";
import {
  ContentsListQuery,
  DeleteContentsMutation,
  RestoreContentsMutation,
} from "@/admin/entities/contents";
import {
  useContentsManagement,
  type ContentRow,
  ContentsSchemas,
} from "../model";
import { ContentShow } from "..";

/**
 * UI компонент для управления контентом
 * Чистый презентационный компонент, использует логику из model слоя
 * GraphQL операции импортирует из contents entity
 * Редактирования нет — только просмотр (details) и delete/restore
 */
export function Contents() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useContentsManagement();

  return (
    <CRUD<ContentRow>
      listQuery={ContentsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={ContentsSchemas.filterSchema}
      editSchema={{
        ...ContentsSchemas.editSchema,
        details: {
          ...ContentsSchemas.editSchema.details,
          showComponent: ContentShow,
        },
      }}
      deleteMutation={DeleteContentsMutation}
      restoreMutation={RestoreContentsMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
